import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  sendRequest,
  changeQueryParams,
  selectQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import SearchInput from '../../../../components/Common/Inputs/SearchInput';

class TaskSearchInputs extends Component {
  changeQueryParams = changeParams => {
    this.props.changeQueryParams({ ...changeParams, ...{ page: 1 } });
    this.props.sendRequest();
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="panelGroupFilter_h_5">
          <a
            className="dropdown-toggle dropdown-toggle-collapse collapsed"
            role="button"
            data-toggle="collapse"
            href="#panelGroupFilter_c_5"
            aria-expanded="false"
            aria-controls="panelGroupFilter_c_5"
          >
            {t('Поиск задания')}
          </a>
        </div>
        <div
          id="panelGroupFilter_c_5"
          className="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="panelGroupFilter_h_5"
        >
          <div className="panel-body">
            <div className="form-group form-group-sm m-b-0">
              <label
                className="control-label control-label-light sr-only"
                htmlFor="taskSearch"
              >
                {t('Поиск задания')}
              </label>
              <div className="input-group">
                <SearchInput
                  type="search"
                  className="form-control"
                  id="taskSearch"
                  placeholder=""
                  onChange={e => {
                    this.changeQueryParams({
                      searchString: e.target.value
                    });
                  }}
                  value={this.props.selectQueryParams.searchString}
                />
                <span className="input-group-btn">
                  <button className="btn btn-sm btn-default" type="button">
                    <i className="fa fa-search" />
                  </button>
                </span>
              </div>
              <small className="help-block m-b-0">
                {t('Поиск по id, названию, тексту')}
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TaskSearchInputs.propTypes = {
  // CONNECT
  selectQueryParams: PropTypes.shape({
    searchString: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.listReduceName)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskSearchInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskSearchForm/TaskSearchInputs/TaskSearchInputs.js